import { render, staticRenderFns } from "./ExtraBonusMore.vue?vue&type=template&id=a17f806e&scoped=true"
import script from "./ExtraBonusMore.vue?vue&type=script&lang=js"
export * from "./ExtraBonusMore.vue?vue&type=script&lang=js"
import style0 from "./ExtraBonusMore.vue?vue&type=style&index=0&id=a17f806e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17f806e",
  null
  
)

export default component.exports